import { Printer } from "lucide-react";

/**
 * La stampa, in un posto solo.
 *
 * Ogni sezione dell'app deve poter finire su un foglio: il cliente consegna il registro della
 * piscina al condominio, porta in cantiere l'elenco delle strutture coi referenti e attacca in
 * furgone i telefoni della squadra. Non si costruisce una stampa per sezione: si stampa quello
 * che l'utente sta guardando, con la stessa carta per tutti.
 *
 * La stampa e quella del browser, come nel Registro ore: `window.print()` piu il blocco
 * `@media print` del foglio di stile, che toglie menu, barre, filtri e comandi. Qui vivono il
 * pulsante e l'intestazione che compare **soltanto sulla carta**, perche un foglio senza
 * scritto di che cosa parla e da quando non e un documento.
 */
export function PrintButton({ label = "Stampa" }: { label?: string }) {
  return (
    <button type="button" className="button button--outline" onClick={() => window.print()}>
      <Printer size={18} /> {label}
    </button>
  );
}

/** La data di oggi come si scrive su un documento. */
export function printedOn(now: Date = new Date()) {
  return now.toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" });
}

/**
 * L'intestazione del foglio: che cosa si sta stampando, con quali filtri e in che giorno.
 *
 * I dettagli sono i filtri e la ricerca attivi, scritti a parole: chi riceve il foglio deve
 * capire che non ha in mano tutto l'elenco ma la parte che qualcuno ha scelto.
 */
export function PrintSheetHeading({ title, details }: { title: string; details?: Array<string | null | undefined> }) {
  const scritti = (details ?? []).filter((dettaglio): dettaglio is string => Boolean(dettaglio && dettaglio.trim()));
  return (
    <div className="print-sheet">
      <strong>{title}</strong>
      {scritti.length > 0 && <span className="print-sheet__details">{scritti.join(" · ")}</span>}
      <span className="print-sheet__date">Stampato il {printedOn()}</span>
    </div>
  );
}
